document.addEventListener("DOMContentLoaded", async function () {
  const storageKey = "viewed-products";
  const wrapperId = "viewed-products-wrapper";
  const templateId = "viewed-product-template";

  // LocalStorage から取得
  function getRecentlyViewed() {
    try {
      const data = JSON.parse(localStorage.getItem(storageKey)) || [];
      return data;
    } catch (error) {
      return [];
    }
  }

  // LocalStorage に保存
  function saveRecentlyViewed(products) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(products));
    } catch (error) {
      console.error("⚠️ LocalStorage 保存エラー:", error);
    }
  }

  // 閲覧商品を記録
  function recordRecentlyViewed(maxItems = 4) {
    if (!window.location.pathname.includes("/products/")) {
      return;
    }

    const productHandleMatch = window.location.pathname.match(/\/products\/([^\/]+)/);
    if (!productHandleMatch) {
      return;
    }

    const productHandle = productHandleMatch[1];
    let recentlyViewed = getRecentlyViewed();

    // 重複削除 → 先頭追加
    recentlyViewed = recentlyViewed.filter((item) => item !== productHandle);
    recentlyViewed.unshift(productHandle);

    // 上限数を超えたら末尾削除
    if (recentlyViewed.length > maxItems) {
      recentlyViewed.pop();
    }

    saveRecentlyViewed(recentlyViewed);
  }

  // 閲覧商品を表示
  async function showRecentlyViewed() {
    const recentlyViewed = getRecentlyViewed();
    const wrapper = document.getElementById(wrapperId);
    const template = document.getElementById(templateId)?.content;

    // 表示件数の上限（data-max属性から取得）
    const maxItems = parseInt(wrapper?.dataset.max || "4", 10);

    if (!wrapper) {
      return;
    }
    if (!template) {
      wrapper.style.display = "none";
      return;
    }

    wrapper.innerHTML = "";
    const howManyToShow = Math.min(recentlyViewed.length, maxItems);

    for (const productHandle of recentlyViewed.slice(0, howManyToShow)) {
      try {
        // 商品ハンドルをデコード
        const decodedHandle = decodeURIComponent(productHandle);

        const response = await fetch(`/products/${decodedHandle}.js`);
        if (!response.ok) throw new Error(`HTTPエラー: ${response.status}`);
        const product = await response.json();

        // 書籍のみ表示
        if (product.type !== "書籍" && product.type !== "jmedmook") {
          continue;
        }

        const imageUrl =
          product.featured_image ||
          "https://cdn.shopify.com/s/files/1/0576/3458/6727/files/estate-0-NO_IMAGE.jpg?v=1738245579";

        //金額
        const priceOriginal = product.variants[0].price;
        const taxPrice = priceOriginal / 100;
        const priceYen = Math.round(taxPrice / 1.1);
        const formatYen = (val) =>
          new Intl.NumberFormat("ja-JP", {
            minimumFractionDigits: 0,
          }).format(val) + "円";
        const priceText = `定価：${formatYen(taxPrice)}（本体${formatYen(priceYen)}＋税）`;

        // テンプレートをクローン
        const productClone = document.importNode(template, true);
        productClone.querySelector(".recently-viewed-product-link").href = product.url;
        productClone.querySelector(".recently-viewed-product-img").src = imageUrl;
        productClone.querySelector(".recently-viewed-product-img").alt = product.title;
        productClone.querySelector(".recently-viewed-product-link h3").textContent = product.title;
        productClone.querySelector(".recently-viewed-product-link p.category").textContent = product.type;
        productClone.querySelector(".recently-viewed-product-link p.price").textContent = priceText;

        wrapper.appendChild(productClone);
      } catch (error) {
        console.warn(`商品取得エラー [${productHandle}]:`, error);
      }
    }
  }

  // 実行
  const maxItems = parseInt(document.getElementById(wrapperId)?.dataset.max || "4", 10);
  recordRecentlyViewed(maxItems);
  await showRecentlyViewed();
});
